const timeGameList = [
    {
      key: "factFiction",
      label: "Fact & Fiction",
      description: "Spot the truth! Choose the real fact from the fake one.",
    },
    {
      key: "timelineScramble",
      label: "Timeline Scramble",
      description: "Think fast! Put the events in the correct order.",
    },
    {
      key: "speechBubble",
      label: "Speech Bubble",
      description: "Get creative! What might this person have said?",
    },
    {
      key: "mindSnap",
      label: "MindSnap",
      description: "Quick! Pick the right answer before time runs out.",
    }
  ];

  const spaceGameList = [
    {
      key: "mindSnap",
      label: "MindSnap",
      description: "Quick! Pick the right answer before time runs out.",
    },
    {
      key: "mirrorShot",
      label: "Mirror Shot",
      description:
        "Match the moment! Take a photo from the same angle as shown.",
    },
    {
      key: "factFiction",
      label: "Fact & Fiction",
      description: "Spot the truth! Choose the real fact from the fake one.",
    },
    {
      key: "askAIGame",
        label: "Ask the AI",
      description: "You get to ask one question to the AI. Make it count!",
    },
  ];

  const categoryRoutes = {
      mindSnap: "mindSnap",
      factFiction: "factFiction",
      mirrorShot: "mirrorShot",
      speechBubble: "speechBubble",
      timelineScramble: "timelineScramble",
      askAIGame:"askAIGame",
    };

  export {timeGameList,spaceGameList,categoryRoutes}